import React, { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { Button, Input, SubTitle } from "../../Components/CustomComponents";
import Table from "../../Components/Table/Table";
import styles from "./styles/training_management.module.scss";

//
import { Col, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
import { ShimmerTable } from "react-shimmer-effects";
import CustomSpinner from "../../Components/CustomComponents/CustomSpinner";
import DeleteModal from "../../Components/Modals/DeleteModal";
import UpdateCategoryModal from "../../Components/Modals/UpdateCategory";
import {
  useGetAllServiceTypeQuery,
  useUpdateServiceTypeMutation,
  useDeleteServiceTypeMutation,
  useAddServiceTypeMutation,
} from "../../Data/services/trainingApi";
import Toast, { ErrorToast, SuccessToast } from "../../Hooks/useToast";

const ServiceTypesManagementScreen = ({ setPage }) => {
  const dispatch = useDispatch();

  const [viewData, setViewData] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [UpdateModal, setUpdateModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo
  const [isChecked, setIsChecked] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const { handleSubmit, control } = useForm({});
  const [userSlug, setUserSlug] = useState("");
  const statusList = [
    { label: "Friend", value: "friend" },
    { label: "Public", value: "public" },
    { label: "Private", value: "private" },
  ];

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllServiceTypeQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        limit: pageSize,
        page: currentPage,
      },
      { refetchOnMountOrArgChange: true }
    );

  const handleSearchChange = (value) => {
    setSearchQuery(value);
  };

  // var allPosts = useSelector((state) => state.posts.data);
  // console.log(`allPosts = ${allPosts}`);

  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(data.data);
      setDataFetched(true);
    }
  }, [data]);

  const handleUpdateModalOpen = () => {
    setUpdateModal(true);
  };

  const handleUpdateModalClose = () => {
    setUpdateModal(false);
    setViewData("");
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setViewData("");
  };

  const [deleteServiceType, { isLoading: isDeleting }] =
  useDeleteServiceTypeMutation();
  const [updateServiceType, { isLoading: addloading }] =
  useUpdateServiceTypeMutation();
  const [addServiceType, { isLoading: editLoading }] =
  useAddServiceTypeMutation();

  const deleteData = async (id) => {
    // console.log(editedData.slug);
    // console.log(id);

    const postSlug = id;

    try {
      const { data } = await deleteServiceType(postSlug);

      // console.log(data);

      if (data.code === 200) {
        await refetch();
        handleDeleteModalClose();
        SuccessToast(data.message);
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
  };

  function indication() {
    return dataFetched && rowData?.length > 0 ? (
      <ShimmerTable row={5} col={1} />
    ) : (
      <p>NO DATA FOUND</p>
    );
  }
  const columns = [
    {
      dataField: "name",
      text: "Service Type Name",
      headerStyle: {
        width: "150px",
      },
      formatter: (cellContent, row) => {
        return <td>{`${row?.name || ""}`}</td>;
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "160px",
      },
      formatter: (cellContent, row) => {
        // console.log(row)
        if (row.id) {
          return (
            <div className="d-flex justify-content-end gap-3 align-items-center">
              {/* <Link
                to={`${process.env.REACT_APP_DOMAIN_DIR}/training/category/${row.id}`}
                className="text-decoration-none w-50"
              >
                <div
                  className={`${styles.btnBg} d-flex justify-content-center align-items-center text-white rounded-3 mx-2 p-2 `}
                  role="button"
                  onClick={() => {
                    setViewData(row);
                    handleUpdateModalOpen(true);
                  }}
                >
                  <span
                    className={`align-items-center d-flex justify-content-start pe-1 `}
                  ></span>
                  <span className="fw-bold">{row?.name} Training</span>
                </div>
              </Link> */}
              <div
                className="d-flex justify-content-center align-items-center tag_button text-white rounded-3 p-2 mx-2 w-25"
                role="button"
                onClick={() => {
                  setViewData(row);
                  handleUpdateModalOpen(true);
                  setUserSlug(row.id);
                }}
              >
                <span className={`d-flex align-items-center pe-1`}>
                  {/* <MdDeleteForever /> */}
                </span>
                <span>Edit</span>
              </div>
              <div
                className="d-flex justify-content-center align-items-center delete_button text-white rounded-3 p-2 mx-2 w-25"
                role="button"
                onClick={() => {
                  setViewData(row);
                  handleDeleteModalOpen(true);
                  setUserSlug(row.id);
                }}
              >
                <span className={`d-flex align-items-center pe-1`}>
                  {/* <MdDeleteForever /> */}
                </span>
                <span>Delete</span>
              </div>
            </div>
          );
        }
      },
    },
  ];

  const OnSubmit = async (record) => {
    try {
      const payload = {
        slug: userSlug,
        data: { ...record },
      };
      let response;
      if (userSlug) {
        response = await updateServiceType(payload);
      } else {
        response = await addServiceType(payload);
      }

      if (response?.error?.status === 400) {
        console.log(response?.error?.data?.message);
        ErrorToast(response?.error?.data?.message, "error");
      }

      if (response?.error?.status === 500) {
        ErrorToast(response?.error?.data?.message, "error");
      }

      if (response.data) {
        SuccessToast(response?.data?.message);
        handleUpdateModalClose();
        refetch();
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      }
    }
  };

  return (
    <div className={styles.MainContainer}>
      {deleteModal ? (
        <DeleteModal
          handleDeleteModalClose={handleDeleteModalClose}
          data={viewData}
          onDelete={deleteData}
          isDeleting={isDeleting}
        />
      ) : (
        ""
      )}
      {UpdateModal ? (
        <UpdateCategoryModal
          handleUpdateModalClose={handleUpdateModalClose}
          data={viewData}
          refetch={refetch}
          submitFunction={OnSubmit}
          modalName={"Service Type"}
          loading={addloading || editLoading}
        />
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <Row className="w-100 flex-start justify-content-between">
          <Col md={5}>
            <div>
              <SubTitle text={"Service Types Management"} classes="primary-text" />
            </div>
          </Col>
          <Col md={4}>
            <Input
              placeholder="search by name"
              value={searchQuery}
              onChange={(e) => handleSearchChange(e.target.value)}
            />
          </Col>
          {/* <Col md={2}>
            <Controller
              control={control}
              name="post_type"
              rules={{}}
              defaultValue={selectedStatus}
              render={({ field: { onChange, onBlur, value, ref } }) => (
                <SelectFieldComponent
                  firstOption={
                    _.isEmpty(selectedStatus) ? "Select Type" : selectedStatus
                  }
                  optionsList={statusList}
                  onSelectChange={(newValue) => {
                    onChange(newValue);
                    setSelectedStatus(newValue);
                  }}
                />
              )}
            />
          </Col> */}
          <Col md={3}>
            <Button
              classes={`h-100 mt-3 mt-md-0`}
              text="Add Service Types"
              onClick={handleUpdateModalOpen}
            ></Button>
          </Col>
        </Row>
      </div>

      <div className={styles.mainTable}>
        {!dataFetched ? (
          <CustomSpinner />
        ) : (
          <Table
            classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
            data={rowData ?? []}
            columns={columns}
            indication={indication}
            totalRecords={totalRecords} // todo
            totalPages={totalPages} // todo
            pageSize={pageSize} // todo
            currentPage={currentPage} // todo
            setCurrentPage={setCurrentPage} // todo
            setPageSize={setPageSize} // todo
            refetch={refetch} // todo
          />
        )}
      </div>
    </div>
  );
};

export default ServiceTypesManagementScreen;
